import React from 'react'

import { Formik } from 'formik'
import { connect } from 'react-redux'

import * as auth from 'store/ducks/auth.duck'

import * as AuthService from 'services/auth.service'

function Login(props) {
  const aniosOptions = React.useMemo(() => {
    const anioActual = new Date().getFullYear()
    const limiteAnios = anioActual - 10

    const output = []

    for (let i = anioActual + 1; i >= limiteAnios; i--) {
      output.push(
        <option key={i} value={i}>
          {i}
        </option>
      )
    }

    return output
  }, [])

  return (
    <>
      <Formik
        initialValues={{
          username: '',
          contrasena: '',
          anio: new Date().getFullYear()
        }}
        onSubmit={(values, { setStatus, setSubmitting }) => {
          AuthService.login(values)
            .then(({ accessToken }) => {
              props.setToken(accessToken)
              window.location.reload()
            })
            .catch(() => {
              setSubmitting(false)
              setStatus('Usuario y/o contraseña incorrecta.')
            })
        }}
      >
        {({ values, status, handleChange, handleBlur, handleSubmit, isSubmitting }) => (
          <form noValidate={true} autoComplete='off' className='kt-form' onSubmit={handleSubmit}>
            {status && (
              <div role='alert' className='alert alert-danger'>
                <div className='alert-text'>{status}</div>
              </div>
            )}

            <input
              type='text'
              name='username'
              id='username'
              className='zr-input zr-block login-input'
              placeholder='USUARIO'
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.username}
              disabled={isSubmitting}
            />

            <input
              type='password'
              name='contrasena'
              id='contrasena'
              className='zr-input zr-block login-input'
              placeholder='CONTRASEÑA'
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.contrasena}
              disabled={isSubmitting}
            />

            <select
              id='anio'
              name='anio'
              className='zr-select zr-block login-select'
              onBlur={handleBlur}
              onChange={handleChange}
              value={values.anio}
              disabled={isSubmitting}
            >
              {aniosOptions}
            </select>

            <button className='zr-btn zr-btn-primary zr-block login-btn' disabled={isSubmitting}>
              INICIAR SESIÓN
            </button>
          </form>
        )}
      </Formik>
    </>
  )
}

export default connect(null, auth.actions)(Login)
